const LearnMore = () => <>Learn more!</>;

export default LearnMore;